import { Modal } from "@mui/material";
import { BrandPanel } from "./Brand";

export function PostLoginModal({open, setOpen}) {

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    padding: 20,
                    borderRadius: 5,
                }}
            >
                <p>
                    <BrandPanel setOpen={setOpen} closeDialog={() => setOpen(false)} />
                </p>
            </div>
            
        </Modal>
    )
}